import cookie from 'cookie'

const name = 'bearer'

export const removeBearerToken = () => {
  document.cookie = cookie.serialize(name, undefined, {
    maxAge: 0,
    path: import.meta.env.BASE_URL,
  })
}

export const getBearerToken = () => {
  return cookie.parse(document.cookie)[name]
}

export const hasBearerToken = () => {
  return !!getBearerToken()
}
